
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/sale/[childSlug]",
      function () {
        return require("private-next-pages/shop/sale/[childSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/sale/[childSlug]"])
      });
    }
  